export const Home = `
<path d='M485 0L0 273.487V1024H323.333V603.25H646.667V1024H970V273.487L485 0Z'/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/home.js